import { fetcher } from "helpers/fetcher";

import { TAddClientPostReq, TAddClientPostRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addClientPost = async (payload: TAddClientPostReq) => {
  return await fetcher<TAddClientPostRes, TAddClientPostReq>(
    ENDPOINT.USER.ADD_CLIENT_POST,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_CLIENT_POST.version,
      },
    }
  );
};

export const mutationAddClientPost = async (payload: TAddClientPostReq) => {
  return (await addClientPost(payload)).data.message;
};

mutationAddClientPost._key = (payload: TAddClientPostReq) => [
  ENDPOINT.USER.ADD_CLIENT_POST.url,
  payload,
];
